import { Tag } from 'antd'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'
import { colors } from '@lmc/common/constants'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'
import { THIRD_PARTY_DATA } from '@lmc/ui-kit/src/dataDisplay/PageHeader/PageHeader'
import chartTitles from '../chartTitles'
import dayjs from 'dayjs'

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const PAIN_LEVELS = {
  0: 'NA',
  1: 'Mild',
  2: 'Moderate',
  3: 'Severe',
}

export default withToolbar(LineChart, {
  title: (
    <TitleContainer>
      PainChek Assessments
      <Tag color="orange">
        <Text level={2}>{THIRD_PARTY_DATA}</Text>
      </Tag>
    </TitleContainer>
  ),
  pdfExport: {
    title: 'PainChek Assessments',
  },
  timeWindow: 7 * 4,
  childProps: {
    title: chartTitles.painchek,
    legendEnabled: true,
    yMax: 3,
    yAxisCategories: [
      `<div style="font-weight: bold; color: ${colors.darkgrey}">NA</div>`,
      `<div style="font-weight: bold; color: ${colors.green}">Mild</div>`,
      `<div style="font-weight: bold; color: ${colors.yellow}">Moderate</div>`,
      `<div style="font-weight: bold; color: ${colors.red}">Severe</div>`,
    ],
    series: [
      {
        type: 'painchekAtRest',
        label: 'At Rest',
      },
      {
        type: 'painchekPostMovement',
        label: 'Post Movement',
      },
    ],
    yAxisLabel: 'Pain Level',
    tooltip: {
      formatter() {
        return `<strong style="font-size: 10px; opacity: 0.7;">${dayjs(
          this.x,
        ).format(
          'dddd Do MMMM YYYY HH:mm',
        )}</strong><br /> <span style="color: ${this.series.color};">●</span> ${this.series.name}: <strong>${
          PAIN_LEVELS[this.y]
        }</strong>`
      },
    },
  },
})
